import { render, staticRenderFns } from "./SignedPoliciesListView.vue?vue&type=template&id=1a5bfcc0"
import script from "./SignedPoliciesListView.vue?vue&type=script&lang=ts"
export * from "./SignedPoliciesListView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports